import { styled } from '@mui/material';
import { Typography } from '@mui/material';

export const KPIRow = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  gap: 2%;
  height: 100%;
`;
export const KPIColumn = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2%;
`;

export const KPIValue = styled(Typography)``;
export const KPIUnit = styled(Typography)``;
